import { GlButton, GlIcon, GlTooltipDirective } from '@gitlab/ui';
import { mapState } from 'pinia';
import { helpPagePath } from '~/helpers/help_page_helper';
import { createCveIdRequestIssueBody } from '~/helpers/cve_id_request_helper';
import HelpIcon from '~/vue_shared/components/help_icon/help_icon.vue';
import { useNotes } from '~/notes/store/legacy_notes';
import { CVE_ID_REQUEST_SIDEBAR_I18N } from '../../constants';
export default {
    name: 'CveIdRequest',
    i18n: {
        ...CVE_ID_REQUEST_SIDEBAR_I18N
    },
    components: {
        GlButton,
        GlIcon,
        HelpIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        iid: {
            required: true,
            type: String
        },
        fullPath: {
            required: true,
            type: String
        }
    },
    data () {
        return {
            showHelp: false
        };
    },
    computed: {
        ...mapState(useNotes, [
            'noteableData'
        ]),
        confidential () {
            return this.noteableData.confidential;
        },
        helpHref () {
            return helpPagePath('user/application_security/cve_id_request');
        },
        showHelpState () {
            return Boolean(this.showHelp);
        },
        tooltipTitle () {
            return this.$options.i18n.description;
        },
        newCveIdRequestUrl () {
            const currUrl = new URL(window.location.href);
            const newUrl = new URL(currUrl.origin);
            newUrl.pathname = '/gitlab-org/cves/-/issues/new';
            const params = {
                'issue[confidential]': 'true',
                // eslint-disable-next-line @gitlab/require-i18n-strings
                'issue[title]': `CVE ID Request - ${this.fullPath}`,
                'issue[description]': createCveIdRequestIssueBody(this.fullPath, this.iid)
            };
            Object.keys(params).forEach((k)=>newUrl.searchParams.append(k, params[k]));
            return newUrl.toString();
        }
    },
    methods: {
        toggleHelpState (show) {
            this.showHelp = show;
        }
    }
};
